/**
 * Contact Form Module
 * Real-time validation, dynamic business fields, anti-spam protections & success modal
 *
 * @package Special_White_Theme
 */
(function() {
  'use strict';

  function initContact() {
    const form = document.getElementById('contact-lead-form');
    if (!form) return;

    const targetTypeSelect = document.getElementById('contact-target-type');
    const otherWrap = document.getElementById('contact-other-wrap');
    const otherInput = document.getElementById('contact-target-other');
    const positionWrap = document.getElementById('contact-position-wrap');
    const positionInput = document.getElementById('contact-position');
    const submitBtn = document.getElementById('contact-submit-btn');
    const alertBox = document.getElementById('contact-form-alert');
    const modal = document.getElementById('contact-success-modal');

    let isSubmitting = false;
    let lastSubmitTime = 0;

    // ─── 0. Multilingual UI Messages & Fallbacks ─────────────────────────
    const i18n = {
      sending: form.getAttribute('data-i18n-sending') || 'Đang gửi thông tin...',
      cooldown: form.getAttribute('data-i18n-cooldown') || 'Bạn vừa gửi một yêu cầu. Vui lòng đợi trong giây lát...',
      reqAll: form.getAttribute('data-i18n-req-all') || 'Vui lòng điền đầy đủ các trường thông tin bắt buộc được đánh dấu đỏ bên dưới.',
      networkErr: form.getAttribute('data-i18n-network-err') || 'Mất kết nối mạng hoặc lỗi máy chủ. Toàn bộ thông tin của bạn vẫn được lưu tại form, vui lòng bấm Gửi lại.',
      nameReq: form.getAttribute('data-i18n-name-req') || 'Vui lòng nhập họ và tên của bạn.',
      nameShort: form.getAttribute('data-i18n-name-short') || 'Họ tên quá ngắn (tối thiểu 2 ký tự).',
      phoneReq: form.getAttribute('data-i18n-phone-req') || 'Vui lòng nhập số điện thoại liên hệ.',
      phoneInvalid: form.getAttribute('data-i18n-phone-invalid') || 'Số điện thoại không hợp lệ (từ 8 đến 15 chữ số).',
      emailReq: form.getAttribute('data-i18n-email-req') || 'Vui lòng nhập địa chỉ email.',
      emailInvalid: form.getAttribute('data-i18n-email-invalid') || 'Địa chỉ email không đúng định dạng.',
      targetReq: form.getAttribute('data-i18n-target-req') || 'Vui lòng chọn đối tượng / loại hình công trình.',
      otherReq: form.getAttribute('data-i18n-other-req') || 'Vui lòng nhập cụ thể đối tượng của bạn.',
      positionReq: form.getAttribute('data-i18n-position-req') || 'Vui lòng nhập vị trí hoặc chức vụ tại doanh nghiệp.',
      addressReq: form.getAttribute('data-i18n-address-req') || 'Vui lòng nhập địa chỉ công trình cần khảo sát.',
      addressShort: form.getAttribute('data-i18n-address-short') || 'Địa chỉ quá ngắn, vui lòng nhập rõ địa chỉ.',
      selectDefault: form.getAttribute('data-i18n-select-default') || '— Chọn đối tượng khảo sát —',
    };

    // ─── 1. Custom Tailwind Dropdown & Dynamic Field Toggles ─────────────
    const dropdownBtn = document.getElementById('contact-target-type-btn');
    const dropdownMenu = document.getElementById('contact-target-type-menu');
    const dropdownLabel = dropdownBtn ? dropdownBtn.querySelector('.dropdown-selected-label') : null;
    const dropdownArrow = dropdownBtn ? dropdownBtn.querySelector('.dropdown-arrow') : null;

    function handleTargetTypeChange() {
      if (!targetTypeSelect) return;
      const val = targetTypeSelect.value;
      const isBusiness = targetTypeSelect.getAttribute('data-business') === '1';

      // Toggle "Khác" input
      if (val === 'other') {
        if (otherWrap) {
          otherWrap.classList.remove('hidden');
          if (otherInput) otherInput.setAttribute('required', 'required');
        }
      } else {
        if (otherWrap) {
          otherWrap.classList.add('hidden');
          if (otherInput) otherInput.removeAttribute('required');
        }
      }

      // Toggle "Vị trí / Chức vụ" if business
      if (isBusiness) {
        if (positionWrap) {
          positionWrap.classList.remove('hidden');
          if (positionInput) positionInput.setAttribute('required', 'required');
        }
      } else {
        if (positionWrap) {
          positionWrap.classList.add('hidden');
          if (positionInput) positionInput.removeAttribute('required');
        }
      }
    }

    if (dropdownBtn && dropdownMenu) {
      function toggleDropdown(show) {
        const isOpen = show !== undefined ? show : dropdownMenu.classList.contains('hidden');
        if (isOpen) {
          dropdownMenu.classList.remove('hidden');
          dropdownBtn.setAttribute('aria-expanded', 'true');
          if (dropdownArrow) dropdownArrow.classList.add('rotate-180');
        } else {
          dropdownMenu.classList.add('hidden');
          dropdownBtn.setAttribute('aria-expanded', 'false');
          if (dropdownArrow) dropdownArrow.classList.remove('rotate-180');
        }
      }

      dropdownBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleDropdown();
      });

      dropdownMenu.querySelectorAll('.dropdown-option').forEach(function(opt) {
        opt.addEventListener('click', function(e) {
          e.stopPropagation();
          const val = opt.getAttribute('data-value');
          const isBiz = opt.getAttribute('data-business');
          const label = opt.getAttribute('data-label-full');

          if (targetTypeSelect) {
            targetTypeSelect.value = val;
            targetTypeSelect.setAttribute('data-business', isBiz);
          }

          if (dropdownLabel) {
            dropdownLabel.textContent = label;
            dropdownLabel.classList.remove('text-slate-400');
            dropdownLabel.classList.add('text-slate-900', 'font-medium');
          }

          if (dropdownBtn) {
            dropdownBtn.classList.remove('border-red-500', 'bg-red-50/30', 'focus:ring-red-500');
            dropdownBtn.classList.add('border-slate-200', 'bg-slate-50', 'focus:ring-[#01469b]');
          }
          if (targetTypeSelect) {
            clearFieldError(targetTypeSelect);
          }

          handleTargetTypeChange();
          toggleDropdown(false);
        });
      });

      document.addEventListener('click', function(e) {
        if (!dropdownBtn.contains(e.target) && !dropdownMenu.contains(e.target)) {
          toggleDropdown(false);
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          toggleDropdown(false);
        }
      });
    }

    if (targetTypeSelect) {
      targetTypeSelect.addEventListener('change', handleTargetTypeChange);
      handleTargetTypeChange();
    }

    // ─── 2. Inline Validation Helpers ────────────────────────────────────
    function setFieldError(fieldId, errorMsg) {
      const field = document.getElementById(fieldId);
      const visualEl = document.getElementById(fieldId + '-btn') || field;
      const errorEl = form.querySelector('[data-error-for="' + (field ? field.name : fieldId) + '"]');
      if (visualEl) {
        visualEl.classList.add('border-red-500', 'bg-red-50/30', 'focus:ring-red-500');
        visualEl.classList.remove('border-slate-200', 'bg-slate-50', 'focus:ring-[#01469b]');
      }
      if (errorEl) {
        errorEl.textContent = errorMsg;
        errorEl.classList.remove('hidden');
      }
    }

    function clearFieldError(field) {
      if (!field) return;
      const visualEl = document.getElementById(field.id + '-btn') || field;
      if (visualEl) {
        visualEl.classList.remove('border-red-500', 'bg-red-50/30', 'focus:ring-red-500');
        visualEl.classList.add('border-slate-200', 'bg-slate-50', 'focus:ring-[#01469b]');
      }
      const errorEl = form.querySelector('[data-error-for="' + field.name + '"]');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.add('hidden');
      }
    }

    function clearAllErrors() {
      const inputs = form.querySelectorAll('input, select, textarea');
      inputs.forEach(clearFieldError);
      if (dropdownBtn) {
        dropdownBtn.classList.remove('border-red-500', 'bg-red-50/30', 'focus:ring-red-500');
        dropdownBtn.classList.add('border-slate-200', 'bg-slate-50', 'focus:ring-[#01469b]');
      }
      if (alertBox) {
        alertBox.classList.add('hidden');
        alertBox.textContent = '';
      }
    }

    // Live clearing on input
    form.querySelectorAll('input, select, textarea').forEach(function(input) {
      input.addEventListener('input', function() {
        clearFieldError(input);
      });
      input.addEventListener('change', function() {
        clearFieldError(input);
      });
    });

    // ─── 3. Client-Side Field Validation ─────────────────────────────────
    function validateForm() {
      clearAllErrors();
      let isValid = true;
      let firstInvalidEl = null;

      // Fullname
      const fullname = document.getElementById('contact-fullname');
      if (!fullname || !fullname.value.trim()) {
        setFieldError('contact-fullname', i18n.nameReq);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = fullname;
      } else if (fullname.value.trim().length < 2) {
        setFieldError('contact-fullname', i18n.nameShort);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = fullname;
      }

      // Phone
      const phone = document.getElementById('contact-phone');
      const cleanPhone = phone ? phone.value.replace(/[^0-9+]/g, '') : '';
      if (!phone || !cleanPhone) {
        setFieldError('contact-phone', i18n.phoneReq);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = phone;
      } else if (!/^(\+?[0-9]{8,15})$/.test(cleanPhone)) {
        setFieldError('contact-phone', i18n.phoneInvalid);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = phone;
      }

      // Email
      const email = document.getElementById('contact-email');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !email.value.trim()) {
        setFieldError('contact-email', i18n.emailReq);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = email;
      } else if (!emailRegex.test(email.value.trim())) {
        setFieldError('contact-email', i18n.emailInvalid);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = email;
      }

      // Target Type
      const targetType = document.getElementById('contact-target-type');
      if (!targetType || !targetType.value) {
        setFieldError('contact-target-type', i18n.targetReq);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = dropdownBtn || targetType;
      } else if (targetType.value === 'other') {
        const targetOther = document.getElementById('contact-target-other');
        if (!targetOther || !targetOther.value.trim()) {
          setFieldError('contact-target-other', i18n.otherReq);
          isValid = false;
          if (!firstInvalidEl) firstInvalidEl = targetOther;
        }
      }

      // Position (if business)
      if (targetType && targetType.value) {
        const isBusiness = targetType.getAttribute('data-business') === '1';
        if (isBusiness) {
          const position = document.getElementById('contact-position');
          if (!position || !position.value.trim()) {
            setFieldError('contact-position', i18n.positionReq);
            isValid = false;
            if (!firstInvalidEl) firstInvalidEl = position;
          }
        }
      }

      // Address
      const address = document.getElementById('contact-address');
      if (!address || !address.value.trim()) {
        setFieldError('contact-address', i18n.addressReq);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = address;
      } else if (address.value.trim().length < 4) {
        setFieldError('contact-address', i18n.addressShort);
        isValid = false;
        if (!firstInvalidEl) firstInvalidEl = address;
      }

      if (!isValid && firstInvalidEl) {
        firstInvalidEl.focus();
        firstInvalidEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return isValid;
    }

    // ─── 4. Modal Popup Controls ─────────────────────────────────────────
    function openSuccessModal() {
      if (!modal) return;
      modal.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    }

    function closeSuccessModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    }

    if (modal) {
      const closeBtn = modal.querySelector('.modal-close-btn');
      if (closeBtn) {
        closeBtn.addEventListener('click', closeSuccessModal);
      }
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          closeSuccessModal();
        }
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeSuccessModal();
        }
      });
    }

    // ─── 5. Form Submission Handling ─────────────────────────────────────
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      // Check double-submit
      if (isSubmitting) return;

      // Rate limit check on client (10 seconds cooldown between clicks)
      const now = Date.now();
      if (now - lastSubmitTime < 5000) {
        if (alertBox) {
          alertBox.className = 'contact-form-alert mb-6 p-4 rounded-xl text-sm bg-amber-50 text-amber-800 border border-amber-200';
          alertBox.textContent = i18n.cooldown;
          alertBox.classList.remove('hidden');
        }
        return;
      }

      // Client validation
      if (!validateForm()) {
        if (alertBox) {
          alertBox.className = 'contact-form-alert mb-6 p-4 rounded-xl text-sm bg-red-50 text-red-700 border border-red-200';
          alertBox.textContent = i18n.reqAll;
          alertBox.classList.remove('hidden');
        }
        return;
      }

      // Enter submitting state
      isSubmitting = true;
      lastSubmitTime = Date.now();

      const btnSpinner = submitBtn ? submitBtn.querySelector('.btn-spinner') : null;
      const btnIcon = submitBtn ? submitBtn.querySelector('.btn-icon') : null;
      const btnText = submitBtn ? submitBtn.querySelector('.btn-text') : null;
      const originalText = btnText ? btnText.textContent : '';

      if (submitBtn) submitBtn.disabled = true;
      if (btnSpinner) btnSpinner.classList.remove('hidden');
      if (btnIcon) btnIcon.classList.add('hidden');
      if (btnText) btnText.textContent = i18n.sending;

      const formData = new FormData(form);

      // Fallback nonce from ginaData if not in form
      if (!formData.get('contact_nonce') && window.ginaData && window.ginaData.contactNonce) {
        formData.append('contact_nonce', window.ginaData.contactNonce);
      }
      if (!formData.get('nonce')) {
        formData.append('nonce', formData.get('contact_nonce') || (window.ginaData && window.ginaData.contactNonce) || '');
      }

      const ajaxUrl = (window.ginaData && window.ginaData.ajaxUrl) ? window.ginaData.ajaxUrl : '/wp-admin/admin-ajax.php';

      fetch(ajaxUrl, {
        method: 'POST',
        body: formData
      })
      .then(function(res) {
        return res.json();
      })
      .then(function(res) {
        isSubmitting = false;
        if (submitBtn) submitBtn.disabled = false;
        if (btnSpinner) btnSpinner.classList.add('hidden');
        if (btnIcon) btnIcon.classList.remove('hidden');
        if (btnText) btnText.textContent = originalText;

        if (res.success) {
          // Success: reset form fields and show modal
          form.reset();
          if (targetTypeSelect) {
            targetTypeSelect.value = '';
            targetTypeSelect.removeAttribute('data-business');
          }
          if (dropdownLabel) {
            dropdownLabel.textContent = i18n.selectDefault;
            dropdownLabel.classList.remove('text-slate-900', 'font-medium');
            dropdownLabel.classList.add('text-slate-400');
          }
          clearAllErrors();
          if (otherWrap) otherWrap.classList.add('hidden');
          if (positionWrap) positionWrap.classList.add('hidden');

          openSuccessModal();
        } else {
          // Error: KEEP ALL DATA! Display errors
          const errMsg = (res.data && res.data.message) ? res.data.message : 'Có lỗi xảy ra, vui lòng thử lại.';
          if (alertBox) {
            alertBox.className = 'contact-form-alert mb-6 p-4 rounded-xl text-sm bg-red-50 text-red-700 border border-red-200';
            alertBox.textContent = errMsg;
            alertBox.classList.remove('hidden');
          }

          if (res.data && res.data.field_errors) {
            for (const key in res.data.field_errors) {
              setFieldError('contact-' + key.replace('_', '-'), res.data.field_errors[key]);
            }
          }
        }
      })
      .catch(function(err) {
        isSubmitting = false;
        if (submitBtn) submitBtn.disabled = false;
        if (btnSpinner) btnSpinner.classList.add('hidden');
        if (btnIcon) btnIcon.classList.remove('hidden');
        if (btnText) btnText.textContent = originalText;

        if (alertBox) {
          alertBox.className = 'contact-form-alert mb-6 p-4 rounded-xl text-sm bg-red-50 text-red-700 border border-red-200';
          alertBox.textContent = i18n.networkErr;
          alertBox.classList.remove('hidden');
        }
      });

    });
  }

  window.GinaContact = { init: initContact };
})();
